import { useEffect } from "react";
import { registerWebPush, onForegroundMessage } from "./FirebaseWebPush";

export default function FirebasePushListener({ username, empresaId }) {
  useEffect(() => {
    if (!username || empresaId == null) return;
    registerWebPush(username, empresaId).catch((e) =>
      console.error("[FirebasePushListener] Error registrando push web:", e)
    );
  }, [username, empresaId]);

  useEffect(() => {
    const unsubscribe = onForegroundMessage(() => {
      // Notificación recibida con la app en foreground: se puede mostrar un toast, actualizar badge, etc.
    });
    return () => unsubscribe && unsubscribe();
  }, []);

  return null;
}
